<template>
  <div class="pb-mini-calendar" v-show="showMiniCalendar">
    <full-calendar ref="mini-calendar" :config="config" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import PopupMixin from '@/mixins/popup';
import { getDayFromCalendarDate } from '@/utils';

export default {
  name: 'MiniCalendar',
  mixins: [PopupMixin],
  data() {
    return {
      config: {
        defaultView: 'month',
        timezone: this.currentTimezone(),
        editable: false,
        selectable: false,
        contentHeight: 'auto',
        fixedWeekCount: false,
        buttonIcons: {
          prev: 'otto-icon-prev',
          next: 'otto-icon-next',
        },
        header: {
          left: 'prev',
          center: 'title',
          right: 'next',
        },
        dayClick: (date) => {
          this.selectDay(moment.utc(date));
          this.toggleMiniCalendar();
        },
      },
    };
  },
  computed: {
    ...mapState({
      showMiniCalendar: state => state.ui.showMiniCalendar,
    }),
  },
  methods: {
    ...mapGetters([
      'currentTimezone',
    ]),
    ...mapActions([
      'toggleMiniCalendar',
      'closeMiniCalendar',
      'setCurrentCalendarDay',
    ]),
    selectDay(date) {
      const day = getDayFromCalendarDate(date);
      this.setCurrentCalendarDay(day);
    },
  },
  watch: {
    showMiniCalendar(newValue) {
      if (newValue === true) {
        this.setupListener(this.closeMiniCalendar);
      } else {
        this.removeListener();
      }
      // toggle active state of calendar icon
      document.querySelector('.otto-icon-cal').classList.toggle('active');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MiniCalendar.vue